import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@Auth/useAuth";
import { LocationsClient } from "@Clients/LocationsClient";
import { locationKeys } from "./locationKeys";

/**
 * Locations for the current org, including each location's `path`/`level`
 * (the `get_locations_with_paths` RPC). This is the single source of truth
 * for location reads across the app.
 */
export function useLocations() {
  const { baseUser } = useAuth();
  const orgId = baseUser?.organization_id;
  return useQuery({
    queryKey: orgId ? locationKeys.all(orgId) : ["locations", "no-org"],
    queryFn: () => LocationsClient.getLocationsByOrganizationId(orgId!),
    enabled: !!orgId,
  });
}
